<template>
  <div class="mr-3 rounded-full bg-gray-500 w-10 relative" :class="isGroupCover ? 'flex flex-wrap content-center' : 'h-10'">
      <template v-if="!isGroup">
        <img v-if="image_url !== ''" :src="image_url" alt="Profile image" class="rounded-full h-10 w-10"/>
        <InlineSVG v-else :src="require(`../../shared/app-menu/assets/avatar-default.svg`)" class="mx-3 my-3 px-1 py-1 bg-white rounded-full"/>
        <SocialMediaLogo :social="social"/>
      </template>
      <template v-else>
        <img v-if="image_url !== '' && isGroupCover" :src="image_url" alt="Profile image" class="rounded-full h-10 w-10"/>
        <img v-else :src="image_url" class="mx-auto mt-2 bg-white rounded-full"/>
        <SocialMediaLogo :social="social"/>
      </template>
  </div>
</template>

<script>
import SocialMediaLogo from "@/components/shared/SocialMediaLogo";
import InlineSVG from 'vue-inline-svg';

export default {
name:"AccountPhoto",
components: {
    SocialMediaLogo,
    InlineSVG
},
props: {
    social: {
      type: String,
      default: "instagram",
    },

    isGroupCover: {
      type: Boolean,
      default: false
    },

    isGroup: {
      type: Boolean,
      default: false
    },

    image_url: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
    width: 16px;
}
</style>